import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-个人中心",
  "use": "icon-个人中心-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-个人中心\"><defs><style type=\"text/css\"></style></defs><path d=\"M153.018 860.44A502.387 502.387 0 0 1 8 506.667c0-278.342 225.658-504 504-504s504 225.658 504 504c0 137.861-55.34 262.752-145.018 353.775A502.454 502.454 0 0 1 512 1010.666a502.454 502.454 0 0 1-358.982-150.225z m29.601-66.863a378.84 378.84 0 0 1 229.354-179.02 201.6 201.6 0 1 1 200.054 0c98.146 26.88 180.365 92.298 229.354 179.02A435.12 435.12 0 0 0 948.8 506.667c0-241.248-195.552-436.8-436.8-436.8S75.2 265.419 75.2 506.667a435.12 435.12 0 0 0 107.42 286.91z\" fill=\"#ffffff\" p-id=\"1711\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/个人中心.svg
// module id = gQHm
// module chunks = 5